import { useState } from "react"
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react"

export default function Calendar({ handleSelect, eventsData = [], handleEventClick }) {
  const [currentDate, setCurrentDate] = useState(new Date())

  const daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate()

  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay()

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]

  const days = []
  for (let i = 0; i < firstDayOfMonth; i++) {
    days.push(null)
  }

  for (let i = 1; i <= daysInMonth; i++) {
    days.push(i)
  }

  const previousMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1))
  }

  const nextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1))
  }

  const handleDayClick = (day) => {
    if (!day) return

    const selectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day)
    const endDate = new Date(selectedDate)
    endDate.setHours(selectedDate.getHours() + 1)

    handleSelect({ start: selectedDate, end: endDate })
  }

  // Check if a day has events
  const getDayEvents = (day) => {
    if (!day) return []

    return eventsData.filter((event) => {
      const eventDate = new Date(event.start)
      return (
        eventDate.getDate() === day &&
        eventDate.getMonth() === currentDate.getMonth() &&
        eventDate.getFullYear() === currentDate.getFullYear()
      )
    })
  }

  return (
    <div className="bg-white rounded-lg shadow p-6 w-full max-w-3xl">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-800">
          {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
        </h2>
        <div className="flex gap-2">
          <button onClick={previousMonth} className="p-2 rounded-full hover:bg-gray-100">
            <ChevronLeftIcon size={20} />
          </button>
          <button onClick={nextMonth} className="p-2 rounded-full hover:bg-gray-100">
            <ChevronRightIcon size={20} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-7 gap-2 mb-2">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <div key={day} className="text-center font-medium text-gray-500 text-sm py-2">
            {day}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-2">
        {days.map((day, index) => {
          const dayEvents = getDayEvents(day)

          return (
            <div
              key={index}
              onClick={() => handleDayClick(day)}
              className={`
                min-h-[80px] p-2 border rounded-lg
                ${day ? "cursor-pointer hover:bg-blue-50" : "bg-gray-50"}
                ${
                  day === new Date().getDate() &&
                  currentDate.getMonth() === new Date().getMonth() &&
                  currentDate.getFullYear() === new Date().getFullYear()
                    ? "border-blue-500"
                    : "border-gray-200"
                }
              `}
            >
              {day && (
                <>
                  <div className="text-right font-medium">{day}</div>
                  {dayEvents.length > 0 && (
                    <div className="mt-1">
                      {dayEvents.map((event, eventIndex) => (
                        <div
                          key={eventIndex}
                          onClick={(e) => {
                            e.stopPropagation()
                            handleEventClick(event)
                          }}
                          className="text-xs bg-blue-100 text-blue-800 rounded px-1 py-0.5 mb-1 truncate"
                        >
                          {event.title}
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
